<template>
  <div :class="tabbarIndex == 3 ? 'height' : ''">
    <div class="contaner" :class="tabbarIndex == 3 ? 'height' : ''">
      <uniBookself
        ref="childSelf"
        v-if="tabbarIndex == 0"
        :pageNo="pageSelfNo"
        @eventChange="changePage"
      >
      </uniBookself>
      <uniBookcity
        ref="childCity"
        v-show="tabbarIndex == 1"
        :pageNo="pageNo"
        @eventChange="changePage"
      >
      </uniBookcity>
      <uniBooktask
        ref="childTask"
        v-if="tabbarIndex == 2"
        @eventTab="changeTab"
      ></uniBooktask>
      <uniBookmine ref="childMine" v-if="tabbarIndex == 3"></uniBookmine>
    </div>
    <!-- :style="{'padding-bottom': paddingBottomHeight + 'rpx'}"  -->
    <div class="tabbar">
        <div
        v-for="(item, index) in tabbar"  :key="index"
        class="tabbar-div"
        @click="changeTabbar(index)"
      >
        <img
          class="tabbar-image"
          :src="tabbarIndex == index ? item.selectedIconPath : item.iconPath"
          alt=""
        />
        <span
          class="tabbar-text"
          :class="tabbarIndex == index ? 'active' : ''"
          >{{ item.text }}</span
        >
      </div>
    </div>
    <div v-if="tabbarIndex != 2" @click="changeTabbar(2)">
      <uniSignicon :isSign="isSign"></uniSignicon>
    </div>
    <div >
      <popActivity :pagetype="0" :tabbarIndex="tabbarIndex" @eventTab="changeTab" ref='popChild'></popActivity>
    </div>
 <div>
 </div>
  </div>
</template>
<script>
import uniBookself from "../../components/bookSelf.vue";
import uniBookcity from "../../components/bookCity.vue";
import uniBooktask from "../../components/bookTask.vue";
import uniBookmine from "../../components/bookMine.vue";
import uniSignicon from "../components/sign-icon.vue";
import popActivity from "../components/pop-activity.vue";

export default {
  components: {
    uniBookcity,
    uniBookself,
    uniBooktask,
    uniBookmine,
    uniSignicon,
    popActivity
  },
  data() {
    return {
      tabbarIndex: 1,
      tabbar:[
        {
          pagePath: "pages/bookSelf/index",
          iconPath: "../../static/shujia.png",
          selectedIconPath: "../../static/clicked-shujia.png",
          text: "书架",
          isShow:true
        },
        {
          pagePath: "pages/bookCity/index",
          iconPath: "../../static/shucheng.png",
          selectedIconPath: "../../static/clicked-shucheng.png",
          text: "书城",
          isShow:true
        },
        {
          pagePath: "pages/bookTask/index",
          iconPath: "../../static/fenlei.png",
          selectedIconPath: "../../static/clicked-fenlei.png",
          text: "福利",
          isShow:true
        },
        {
          pagePath: "pages/bookMine/index",
          iconPath: "../../static/wode.png",
          selectedIconPath: "../../static/clicked-wode.png",
          text: "我的",
          isShow:true
        },
      ],
      pageNo: 1,
      pageSelfNo: 1,
      isSign: "1",
      isTourist: 0, //是否是游客账号 0是1否
      infoCode: "", //手动授权code
      code: "", //静默授权code
      state: "", //静默和手动区分
      is_lhp: false,
      isReload: false,
      paddingBottomHeight: 10,
      isPaysuccess: false,
      isTask:true
    };
  },
  
  mounted(){
    if (this.$route.query.tabIndex != undefined) {
      this.tabbarIndex = this.$route.query.tabIndex;
       this.$base.setStorage("tabbarIndex", this.tabbarIndex);
    } else {
      if (this.$base.getStorage("tabbarIndex")) {
        this.tabbarIndex = this.$base.getStorage("tabbarIndex");
      }
    }
    var openid = this.$base.getStorage("openid");
    var isWxAuthorized = this.$base.getStorage("isWxAuthorized");
    var city = this.$base.getStorage("city");
    if (!openid) {
      //静默登录
    } else  if (isWxAuthorized==0 &&city==1&& openid && !this.$store.state.user.isSNS) {//手动登录
      this.$base.setStorage("isSNS", true);
      this.$store.state.user.isSNS = true;
        setTimeout(() => {
         if (this.tabbarIndex == 3){
          this.$refs.childMine.wexinLogin(true);
        }else{
          this.$commonApi.snsapiUserinfo();
        }
      }, 50)
    
      this.getBookCitySettingData();
    } else {
      this.getBookCitySettingData();
    
    }
	this.$commonApi.share()
    if (this.$base.getStorage("isSign") !== "") {
      this.isSign = this.$base.getStorage("isSign");
    }
  },
    beforeRouteLeave(to, from, next) {
    if (!from.name||from.name == "tabbar"&&this.tabbarIndex==1) {
      from.meta.isBack = true;
      from.meta.keepAlive = true;
         var arr=this.$store.state.user.catch_components;
         if(arr.indexOf('tabbar')<0){
            arr.push('tabbar')
         }
       this.$store.commit('GET_CATCHE_COMPONENTS', arr)
    }else{
       from.meta.isBack = false;
       from.meta.keepAlive = true;
     }
    next();
  },
  activated(){
 if (this.$route.query.tabIndex != undefined) {
      this.tabbarIndex = this.$route.query.tabIndex;
      this.$base.setStorage("tabbarIndex", this.tabbarIndex);
    } else {
      if (this.$base.getStorage("tabbarIndex")) {
        this.tabbarIndex = this.$base.getStorage("tabbarIndex");
      }
    }
      if((this.$route.meta.isBack&&this.tabbarIndex!=1)||((this.tabbarIndex==3||this.tabbarIndex==0)&&!this.$route.meta.isBack)){
        this.commonChildFun();
      }
      if(this.tabbarIndex==1){//切换实时更新继续阅读的数据
        this.$refs.childCity.getContinuReading();
      }
  },
    beforeRouteEnter(to, from, next) {
    next();
  },
  methods: {
    getBookCitySettingData(){
          this.$api.getBookCitySettingData().then(res=>{
            if(res.status==1){
            var data=res.data;
              this.diamondareaShowType=data.diamondareaShowType==1?true:false
              this.commonChildFun();
            }
          })
    },
  
    changeTabbar(index) {
      this.tabbarIndex = index;
      this.pageSelfNo = 1;
      this.$base.setStorage("tabbarIndex", index);
      if (this.$base.getStorage("isSign") != "") {
        this.isSign = this.$base.getStorage("isSign");
      }
      this.commonChildFun();
    },
    changeTab(data) {
      this.tabbarIndex = data.data;
      this.commonChildFun();
      this.$base.setStorage("tabbarIndex", this.tabbarIndex);
    },
    commonChildFun() {
      setTimeout(() => {
        if (this.tabbarIndex == 0) {
          this.$refs.childSelf.contentFun();
          document.title = "书架";
        } else if (this.tabbarIndex == 1) {
          this.$refs.childCity.contentFun(this.diamondareaShowType);
          //  this.$refs.popChild.getPopup();
          this.$refs.childCity.getContinuReading();
          document.title = "书城";
        } else if (this.tabbarIndex == 2) {
          this.$refs.childTask.contentFun();
          document.title = "福利";
        } else {
          this.$refs.childMine.contentFun();
          document.title = "我的";
        }
      }, 50)
       if(this.$route.query.tabIndex){
            this.$router.replace({path:'/'})
        }
      if (this.$base.getStorage("isSign") != "") {
        this.isSign = this.$base.getStorage("isSign");
      }
    },
    changePage(data) {
      if (data.data) {
        if(this.$route.query.tabIndex){
            this.$router.replace({path:'/'})
        }
        this.tabbarIndex = data.data;
        this.commonChildFun();
        // window.scrollTo(0,0)
        this.$base.setStorage("tabbarIndex", this.tabbarIndex);
      } else {
        this.pageNo = 1;
        this.pageSelfNo = 1;
      }
    },
  },
};
</script>

<style scoped>

 
.height {
  height: 100%;
}

.contaner {
  padding-bottom: 45px;
  box-sizing: border-box;
}

.tabbar {
  display: flex;
  position: fixed;
  bottom: 0px;
  width: 100%;
  left:0;
  border-top: 1px solid #f3f3f3;
  padding: 5px 0px;
  background-color: #ffffff;
  /* height:calc(48px + env(safe-area-inset-bottom)); */
  padding-bottom: constant(safe-area-inset-bottom);
  /* 兼容 iOS < 11.2 */
  padding-bottom: env(safe-area-inset-bottom);
  /* 兼容 iOS >= 11.2 */
  /* box-sizing: content-box; */
}
.tabbar > .tabbar-div {
  flex: 1;
}

.tabbar > .tabbar-div > .tabbar-image {
  width: 17px;
  height: 20px;
  display: block;
  margin: 0 auto;
}

.tabbar > .tabbar-div:nth-child(1) > .tabbar-image {
  width: 16.6px;
}

.tabbar > .tabbar-div:nth-child(3) > .tabbar-image {
  width: 21px;
  height: 21px;
}

.tabbar > .tabbar-div:nth-child(4) > .tabbar-image {
  width: 20px;
  height: 17px;
}

.tabbar .tabbar-text {
  display: block;
  text-align: center;
  font-size: 11px;
  color: #bbbbbb;
}
.tabbar > .tabbar-div > .active {
  color: #de3b34;
}
</style>



// WEBPACK FOOTER //
// src/view/tabbar/index.vue